// Currency formatting utilities
// Default currency: KRW (Korean Won)

/**
 * Format number as Korean Won currency
 * @param {number|string} amount - Amount to format
 * @param {string} locale - Locale (default: 'ko-KR')
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (amount, locale = 'ko-KR') => {
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;

  if (isNaN(num)) return '₩0';

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'KRW',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(num);
};

/**
 * Format number with thousand separators (no currency symbol)
 * @param {number|string} amount
 * @returns {string}
 */
export const formatNumber = (amount) => {
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;

  if (isNaN(num)) return '0';

  return new Intl.NumberFormat('ko-KR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(num);
};

/**
 * Format as Won with custom suffix
 * @param {number|string} amount
 * @param {string} suffix - Suffix (default: '원')
 * @returns {string}
 */
export const formatWon = (amount, suffix = '원') => {
  return `${formatNumber(amount)}${suffix}`;
};

/**
 * Parse currency string to number
 * @param {string} currencyString
 * @returns {number}
 */
export const parseCurrency = (currencyString) => {
  if (typeof currencyString === 'number') return currencyString;

  // Remove all non-numeric characters except decimal point and minus
  const cleaned = currencyString.replace(/[^\d.-]/g, '');
  const parsed = parseFloat(cleaned);

  return isNaN(parsed) ? 0 : parsed;
};

/**
 * Default currency symbol
 */
export const CURRENCY_SYMBOL = '₩';
export const CURRENCY_CODE = 'KRW';
export const CURRENCY_NAME = 'Won';
